import { motion } from 'framer-motion';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: flex-start;
  background-color: #f7f7f7;
`;

export const TwoContentWrapper = styled.div`
  margin-top: 50px;
  padding: 50px 0 100px;
  background-color: #f7f7f7;

  @media (max-width: 991.98px) {
    margin-top: 30px;
  }

  @media (max-width: 991.98px) {
    padding: 0 0 3rem;
  }

  @media (max-width: 767.98px) {
    margin-top: 10px;
  }
`;

export const Wrapper = styled.div`
  max-width: 36rem;
  height: fit-content;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: flex-start;
  padding: 3rem 2rem;

  @media (min-width: 48rem) {
    min-width: 48rem;
  }

  @media (min-width: 62rem) {
    min-width: 62rem;
    flex-flow: row wrap;
    justify-content: center;
    justify-content: space-between;
    padding: 3rem 0;
  }

  @media (min-width: 75rem) {
    min-width: 75rem;
  }
`;

export const SectionCaption = styled.div`
  text-align: center;
  padding-bottom: 2rem;

  @media (max-width: 991.98px) {
    padding: 0;
  }

  @media (min-width: 1200px) {
    padding-bottom: 5rem;
  }
`;

export const Title = styled.h2`
  color: #4a4a4a;
  margin-bottom: 0;

  @media (max-width: 1400px) {
    line-height: 40px;
  }

  @media (max-width: 1199.98px) {
    font-size: 26px;
    line-height: 30px;
  }

  @media (max-width: 991.98px) {
    margin: 0;
    padding-top: 3rem;
  }

  @media (max-width: 767.98px) {
    font-size: 20px;
    line-height: 30px;
  }
`;

export const TextWrapper = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: flex-start;

  @media (min-width: 62rem) {
    width: 28rem;
  }

  @media (min-width: 75rem) {
    width: 23.875rem;
  }
`;

export const Header = styled.h3`
  line-height: 30px !important;
`;

export const Description = styled(motion.p)`
  &:nth-child(2) {
    background: #f7f7f7;
    z-index: 1;
  }
  margin-bottom: 1.5rem;
`;

export const ReadMoreWrapper = styled.div`
  width: 100%;
  display: flex;
  margin: 15px 0 45px;

  @media (min-width: 36rem) {
    display: none;
    padding: 0;
  }

  @media (min-width: 48rem) {
    padding: 2rem 0 3rem 0;
  }
`;

export const ReadMore = styled.span`
  z-index: 0;
  cursor: pointer;
  font-family: ${({ dir }) => (dir === 'rtl' ? 'GESSTwoDWTCLight,sans-serif ' : 'DINRegular ')};
  font-size: 0.875rem;
  color: #898989;
  text-decoration: underline;
  transition: all 300ms linear;

  &:hover {
    color: #007bff;
  }

  @media (min-width: 36rem) {
    display: none;
  }

  @media (min-width: 48rem) {
    display: block;
  }
`;

export const ImageButtonWrapper = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: flex-start;

  @media (min-width: 62rem) {
    width: 28rem;
  }

  @media (min-width: 75rem) {
    width: 42.5625rem;
  }
`;

export const ImageContainer = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  margin: 1.5rem 0;
`;

export const LeftImageCenter = styled.div`
  display: flex;
  height: 100%;
  flex-flow: column;
  justify-content: center;
`;

export const Image = styled(LazyLoadImage)`
  width: 100%;
  height: auto;
  object-fit: contain;
`;

export const ExploreButton = styled.a`
  cursor: pointer;
  display: inline-block;
  vertical-align: middle;
  user-select: none;
  border: 1px solid transparent;
  line-height: 1.5;
  font-size: ${({ dir }) => (dir === 'rtl' ? '14px' : '12px')};
  border-radius: 20px;
  padding: 10px 1.5rem;
  min-width: 215px;
  text-align: center;
  text-transform: uppercase;
  background-color: #1b7bdd;
  transition: 0.3s;
  color: #fff;
  font-family: ${({ dir }) => (dir === 'rtl' ? 'GESSTwoDWTCMedium,sans-serif ' : '')};

  &:hover {
    background: #1664b3;
  }

  @media (min-width: 48rem) {
    align-self: flex-start;
  }
`;

export const ExploreButtonCTA = styled.div`
  &[dir='ltr'] {
    button {
      font-family: 'DINMediumAlternate';
      letter-spacing: 1.29px;
    }
  }
  &[dir='rtl'] {
    button {
      font-family: GESSTwoDWTCMedium, sans-serif;
    }
  }
  &.small_screenbutton {
    display: none;
    @media (max-width: 767.98px) {
      display: block;
      text-align: center;
      margin-top: 2rem;
    }
  }
  &.hidden_smscreen {
    display: none;
    @media (min-width: 768px) {
      display: block;
    }
  }
`;
